import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CkeditorConfig } from '@configs/questions.config';
// import { Editor } from 'ngx-editor';
import { GlobalToolbarConfig } from 'src/app/shared/addnewquestion';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import Adapter from '../ckeditorAdapter';
import { ItemService } from '@services/item.service';

@Component({
  selector: 'app-items-sub-part-editor',
  templateUrl: './items-sub-part-editor.component.html',
  styleUrls: ['./items-sub-part-editor.component.scss']
})
export class ItemsSubPartEditorComponent implements OnInit {
  toolbar = GlobalToolbarConfig;
  // editor: Editor = new Editor();
  ckeditorConfig = CkeditorConfig;
  subEditorForm: FormGroup;
  updatedValue: string;
  title = this.translate.instant('questions.ItemSubEditor.option'); //'Option';
  edit = this.translate.instant('questions.ItemSubEditor.edit');
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  notifyMsg : string;
  errorMessage;
  public uploadedFileOptions = [];

  constructor(
    public dialogRef: MatDialogRef<ItemsSubPartEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private fb: FormBuilder,
    public itemServ: ItemService
  ) {
    this.updatedValue = data.value;
    if (data.title) {
      this.title = data.title;
    }
  }
  ngOnInit(): void {
    this.subEditorForm = this.fb.group({
      abc : new FormControl({value: this.updatedValue})
    })
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );

    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemServ);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if(error === 'Exceeded maximum file size of 100 MB'){
          this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
        } else if (error === '') {
          this.itemServ.imageUploadErr.subscribe(x => {
          if(x == true) this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          // this.itemServ.imageUploadErr.unsubscribe();
        });
      }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions = []
        this.uploadedFileOptions.push(res.fileName)
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  updateAndClose() {
    if (this.updatedValue.length === 0) {
      const newArr = this.translate.instant('questions.ItemSubEditor.notifyMsg')
      newArr.forEach(element => {
        if(element.key === this.title){
          this.notifyMsg = element.value
        }
      });
      this.webErrorService.customErrors(`${this.notifyMsg}`, true, 'warn')
      return;  // Used to display alert message
    }
    this.notificationService.success(`${this.title} ` + this.translate.instant('questions.ItemSubEditor.updateSucessMsg'));
    this.dialogRef.close(this.updatedValue.replace(/&nbsp;/g,'').trim()
    // .replace(/<img/g, '<img width="100" height="100"')
  );
    this.itemServ.fileName.next(this.uploadedFileOptions)
  }
}

